<template>
   <div class="features text-center">
      <div class="md-layout text-center">
            <div class="md-layout-item md-size-90 md-small-size-100 mx-auto">
              <h2 class="title">
               Nuestros Servicios
              </h2>
              <h3 class="description">
               Hotel Brisas de Lago, contamos con las instalaciones para tus eventos, cursos, retiro empresarial o celebración.
               Somos tu mejor opción para una experiencia increíble. 
              </h3>
            </div>
          </div>
           <div class="md-layout">
              <div class="md-layout-item md-size-33 md-small-size-100">
                
                <div class="info">
                  <div class="icon icon-info">
                    <md-icon>cake</md-icon>
                  </div>
                  <h4 class="info-title">
                    XV Años
                  </h4>
                </div>
              </div>
              <div class="md-layout-item md-size-33 md-small-size-100">
                <div class="info">
                  <div class="icon icon-warning">
                    <md-icon>favorite</md-icon>
                  </div>
                  <h4 class="info-title">
                    Bodas
                  </h4>
                </div>
              </div>
              <div class="md-layout-item md-size-33 md-small-size-100">
                <div class="info">
                  <div class="icon icon-info">
                    <md-icon>family_restroom</md-icon>
                  </div>
                  <h4 class="info-title">
                    Festejos Familiares 
                  </h4>
                </div>
              </div>
            </div>
            <div class="md-layout">
              <div class="md-layout-item md-size-33 md-small-size-100">
                <div class="info">
                  <div class="icon icon-info">
                    <md-icon>hotel</md-icon>
                  </div>
                  <h4 class="info-title">
                    Comodidad
                  </h4>
                  <h5>
      
                  Tiene 10 habitaciones; cada una con vista <br>  al lago, TV por cable y baño privado. 
                    <br>WiFi disponible en todo el hotel <br> y estacionamiento privado. 
                  </h5>
                   
                </div>
              </div>
              <div class="md-layout-item md-size-33 md-small-size-100">
                <div class="info">
                  <div class="icon icon-warning">
                    <md-icon>kitesurfing</md-icon>
                  </div>
                  <h4 class="info-title">
                    Diversión
                  </h4>
                  <h5>
                Tener el lago a unos pasos nos permite <br> romper las olas practicando wakeboard 
                o prueba tu resistencia remando por todo el lago un kayak.
                  </h5>
                </div>
              </div>
              <div class="md-layout-item md-size-33 md-small-size-100">
                <div class="info">
                  <div class="icon icon-info">
                    <md-icon>self_improvement</md-icon>
                  </div>
                  <h4 class="info-title">
                    Relajación
                  </h4>
                  <h5>
                    Con la vista panorámica del lago, el jardín impecable y una alberca privada nos da <br> pie a pasar 
                    un buen rato de desestrés <br>  con la familia y amigos.
                  </h5>
                </div>
              </div>
            </div>
          </div>
</template>

<script>
export default {

}
</script>

<style>

</style>